<template>
  <!-- ตั้งค่าแผนเส้นทาง: upcountryPlanConfig/default. Staff may change it; a value
       that is not valid is stored as its default (P.normalizePlanConfig), and
       the dialog shows what was stored and says so. -->
  <v-dialog :value="value" max-width="640" scrollable @input="$emit('input', $event)">
    <v-card v-if="edit">
      <v-card-title>ตั้งค่าแผนเส้นทางรถใหญ่</v-card-title>
      <!-- pt-3: the first row's floating labels sit above their fields, and the
           scrolling card text clipped them under the title. -->
      <v-card-text class="pt-3 plan-settings">
        <v-row dense>
          <v-col cols="4"><v-text-field v-model="edit.day1EarliestStart" type="time" label="วันแรกออกได้ตั้งแต่" dense outlined /></v-col>
          <v-col cols="4"><v-text-field v-model="edit.laterEarliestStart" type="time" label="วันถัดไปออกได้ตั้งแต่" dense outlined /></v-col>
          <v-col cols="4"><v-text-field v-model="edit.dayEnd" type="time" label="เลิกงานไม่เกิน" dense outlined /></v-col>
          <v-col cols="3"><v-text-field v-model="edit.shopOpen" type="time" label="ร้านรับของ ตั้งแต่" dense outlined /></v-col>
          <v-col cols="3"><v-text-field v-model="edit.shopClose" type="time" label="ถึง" dense outlined /></v-col>
          <v-col cols="3"><v-text-field v-model="edit.homeOpen" type="time" label="บ้านรับของ ตั้งแต่" dense outlined /></v-col>
          <v-col cols="3"><v-text-field v-model="edit.homeClose" type="time" label="ถึง" dense outlined /></v-col>
          <v-col cols="4"><v-text-field v-model.number="edit.install" type="number" label="ติดตั้ง (นาที)" dense outlined /></v-col>
          <v-col cols="4"><v-text-field v-model.number="edit.drop" type="number" label="ส่งอย่างเดียว (นาที)" dense outlined /></v-col>
          <v-col cols="4"><v-text-field v-model.number="edit.unknown" type="number" label="ยังไม่ทราบ (นาที)" dense outlined /></v-col>
          <v-col cols="6"><v-text-field v-model.number="edit.capDay1" type="number" label="วันแรก ระยะแนะนำ (กม.)" dense outlined /></v-col>
          <v-col cols="6"><v-text-field v-model.number="edit.capLater" type="number" label="วันถัดไป ระยะแนะนำ (กม.)" dense outlined /></v-col>
        </v-row>
        <div class="caption mb-1">ระยะแนะนำต่อวันรายภูมิภาค (เว้นว่าง = ใช้ค่าด้านบน)</div>
        <v-simple-table dense>
          <thead><tr><th>กลุ่ม</th><th>วันแรก (กม.)</th><th>วันถัดไป (กม.)</th></tr></thead>
          <tbody>
            <tr v-for="g in edit.groups" :key="g.key">
              <td>{{ g.label }}</td>
              <td><v-text-field v-model="g.day1" type="number" dense hide-details /></td>
              <td><v-text-field v-model="g.later" type="number" dense hide-details /></td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-alert v-if="fellBack" dense type="warning" class="mt-2">บางค่าไม่ถูกต้อง จึงใช้ค่าเริ่มต้นแทน — โปรดตรวจสอบ</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('input', false)">ปิด</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import U from '@/components/upcountry'
import US from '@/components/upcountryService'
import { reportError } from '@/components/report'

const num = v => (v === '' || v == null ? null : Number(v))

export default {
  name: 'upcountryPlanSettings',
  props: { value: Boolean, cfg: { type: Object, required: true }, user: { type: String, default: '' } },
  data () { return { edit: null, saving: false, fellBack: false } },
  watch: {
    value (open) {
      if (!open) return
      this.fellBack = false
      this.fill(this.cfg)
    }
  },
  methods: {
    // The form's fields from a config (the one in force, or what was just stored).
    fill (c) {
      this.edit = {
        day1EarliestStart: c.day1EarliestStart, laterEarliestStart: c.laterEarliestStart, dayEnd: c.dayEnd,
        shopOpen: c.shopWindow.open, shopClose: c.shopWindow.close, homeOpen: c.homeWindow.open, homeClose: c.homeWindow.close,
        install: c.dropMinutes.install, drop: c.dropMinutes.drop, unknown: c.dropMinutes.unknown,
        capDay1: c.kmCap.day1, capLater: c.kmCap.later,
        groups: U.GROUPS.map(g => ({ key: g.key, label: g.label, day1: (c.kmCapByGroup[g.key] || {}).day1 || '', later: (c.kmCapByGroup[g.key] || {}).later || '' }))
      }
    },
    raw () {
      const e = this.edit
      const byGroup = {}
      e.groups.forEach(g => {
        const v = {}
        if (num(g.day1) != null) v.day1 = num(g.day1)
        if (num(g.later) != null) v.later = num(g.later)
        if (Object.keys(v).length) byGroup[g.key] = v
      })
      return {
        day1EarliestStart: e.day1EarliestStart, laterEarliestStart: e.laterEarliestStart, dayEnd: e.dayEnd,
        shopWindow: { open: e.shopOpen, close: e.shopClose }, homeWindow: { open: e.homeOpen, close: e.homeClose },
        dropMinutes: { install: num(e.install), drop: num(e.drop), unknown: num(e.unknown) },
        kmCap: { day1: num(e.capDay1), later: num(e.capLater) },
        kmCapByGroup: byGroup
      }
    },
    async save () {
      this.saving = true
      try {
        const raw = this.raw()
        const clean = await US.setPlanConfig(raw, { user: this.user })
        this.$emit('saved', clean)
        if (JSON.stringify(clean) !== JSON.stringify(raw)) {
          this.fill(clean)
          this.fellBack = true
        } else this.$emit('input', false)
      } catch (e) {
        reportError('upcountry plan settings', e)
        await this.$root.$message('บันทึกไม่สำเร็จ', [U.actionMessage(e)], { type: 'alert', color: 'error', width: 420 })
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
/* Thai stacked marks (ตั้ง) rise above the label's 20px line box, which
   Vuetify clips with overflow: hidden. */
.plan-settings ::v-deep .v-label {
  overflow: visible;
}
</style>
